// extracted by mini-css-extract-plugin
module.exports = {"voucher-card-container":"StoryblokVoucherCard_voucher-card-container__UFfvZ"};